import React from 'react'
import { Outlet } from 'react-router'
import Footer from './Footer'

interface BodyProps {
    renderToastContainer: () => React.ReactNode
}

const Body = ({ renderToastContainer }: BodyProps) => {
    return (
        <>
            <main className="min-h-screen">
                <Outlet />
                { renderToastContainer() }
            </main>
            <Footer />
        </>
    )
}

export default Body
